import * as Yup from 'yup'

const TIPO_INFORME_MEDICO = 299001;
const TIPO_INFORME_RAT = 299002;

export const validationSchemasAtenderInformeProfesional = (codTipoInforme, limitePesadoBytes = 20 * 1000000) => {
  let validationObject = {};

  if (codTipoInforme === TIPO_INFORME_RAT) {
    validationObject["fechaInforme"] = Yup.string().required('Este campo es obligatorio');
  }
  if (codTipoInforme === TIPO_INFORME_MEDICO) {
    validationObject["nroFicha"] = Yup.string().required('Este campo es obligatorio');
    validationObject["fechaInforme"] = Yup.string().required('Este campo es obligatorio');
    validationObject["incapProvicional"] = Yup.string().required('Este campo es obligatorio');
    validationObject["nivelLesion"] = Yup.string().required('Este campo es obligatorio');
    validationObject["incapDefinitiva"] = Yup.string().required('Este campo es obligatorio');
    validationObject["gastosMedicos"] = Yup.string().required('Este campo es obligatorio');
    validationObject["deficiencia"] = Yup.string().required('Este campo es obligatorio');
    validationObject["gastosMedicosFut"] = Yup.string().required('Este campo es obligatorio');
    validationObject["rolLaboral"] = Yup.string().required('Este campo es obligatorio');
    validationObject["perdidaCapLab"] = Yup.string().required('Este campo es obligatorio');
    validationObject["cifraSugerida"] = Yup.string().required('Este campo es obligatorio');
    validationObject["comentarios"] = Yup.string().required('Este campo es obligatorio');
  }
  validationObject.file = Yup
      .mixed()
      .required('Debe adjuntar Informe.')
      .test('fileSize', `Tamaño máximo del archivo ${limitePesadoBytes / 1000000}MB.`,
        (value) => {
            if (!value) return true;
            return value.size <= limitePesadoBytes;
        })

  return Yup.object().shape(validationObject);
}
export const campoEsRequerido = (schema, nombreCampo) => {
  try {
    const field = schema.fields[nombreCampo];
    const tests = field?.tests?.map(t => t.OPTIONS?.name);
    return tests?.includes('required');
  } catch (err) {
    return false;
  }
};